module.exports = __webpack_public_path__ + "static/media/logo.d86775f8.png";